import { NavigateButton } from '@/components';
import { TemplateAbilityGuard } from '@/features/authentication/_components/TemplateAbilityGuard';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router';
import { WorkflowListContent } from '../components/list';
import { useLastWorkflowSearchHistory } from '../hooks/local-storage';
import WorkflowLayout from '../layouts/WorkflowLayout';

const WorkflowListPage: FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { workflowPathWithQuery } = useLastWorkflowSearchHistory();
  const hasSearchParams = location.search !== '';

  // 検索パラメータがなく、かつ前回の検索条件が存在する場合は前回の検索条件を使用する
  const queryString = workflowPathWithQuery.split('?')[1];
  if (!hasSearchParams && queryString) {
    return <Navigate to={`?${queryString}`} replace />;
  }

  return (
    <WorkflowLayout
      headerButtons={
        <TemplateAbilityGuard>
          <NavigateButton path="template" text={t('workflow.template')} />
        </TemplateAbilityGuard>
      }
    >
      <WorkflowListContent />
    </WorkflowLayout>
  );
};

export default WorkflowListPage;
